// import Cookies from 'js-cookie';
import React from 'react';
import { Navigate } from 'react-router-dom';

import Login from '../pages/login/Login';
import LoginLocal from '../pages/login/LoginLocal';

/**
 *
 * Handles the route to the login page.
 * If you try and move got to the login page whilst already being logged in
 * Then you'll be redirected to the dashboard.
 *
 * @returns {object}
 * @example
 * {
 *   path: '/login',
 *   element: <Login />,
 * }
 */
function LoginRoute() {
  const currentURL = window.location.href.replace(/\/$/, '');
  const { port } = window.location;

  const isLocalURL = currentURL === `http://localhost:${port}/login-local`
    || currentURL === 'https://local.prism.jdplc.com.127.0.0.1.nip.io/login-local?user=api'
    || currentURL === 'https://dev.prism.jdplc.com/login-local?user=api';

  let loginLocal;
  if (isLocalURL) {
    loginLocal = <LoginLocal />;
  } else {
    loginLocal = <Navigate to="/login" />;
  }

  return {
    path: '/',
    children: [
      {
        path: 'login',
        element:
  <Login />,
      },
      {
        path: 'login-local',
        element: loginLocal,
      },
    ],
  };
}

export default LoginRoute;
